// client/src/services/apiClient.ts
import axios from "axios";
import i18n from "../i18n";
import { languageManager } from "./languageManager";
const apiClient = axios.create({
    baseURL: import.meta.env.VITE_BACKEND_URL,
    timeout: 30000,
});

/* ===========================
   STEP 2: AUTH INTERCEPTOR
   =========================== */
apiClient.interceptors.request.use(
    (config) => {
        languageManager.requestStarted();
        const token = localStorage.getItem("token");

        config.headers = config.headers ?? {};

        if (token) {
            config.headers.set("Authorization", `Bearer ${token}`);
        }

        config.headers.set("Accept-Language", i18n.language || "en");

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
/* ===========================
   STEP 3: ERROR INTERCEPTOR
   =========================== */
apiClient.interceptors.response.use(
    (response) => {
        languageManager.requestFinished();
        return response;
    },
    (error) => {
        languageManager.requestFinished();

        const message =
            error?.response?.data?.message ||
            error?.response?.data?.detail ||
            "Something went wrong";

        error.message = message;
        
        return Promise.reject(error);
    }
);

export default apiClient;
